import auth, { AuthParams } from '@/utils/authentication';
import { useEffect, useMemo, useState } from 'react';

export type IRoute = AuthParams & {
  name: string;
  key: string;
  // 当前页是否展示面包屑
  breadcrumb?: boolean;
  children?: IRoute[];
  // 当前路由是否渲染菜单项，为 true 的话不会在菜单中显示，但可通过路由地址访问。
  ignore?: boolean;
};

/**
 * 按照顺序调整一下导航顺序
 */
export const routes: IRoute[] = [
  {
    name: 'menu.sipu.admin', // 专业四谱画像
    key: 'sipu',
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
    children: [
      {
        name: 'menu.sipu.ability', //能力图谱
        key: 'eduQuads/ability',
      },
      {
        name: 'menu.sipu.quality', //素养图谱
        key: 'eduQuads/quality',
      },
      {
        name: 'menu.sipu.employment', //就业数据
        key: 'eduQuads/employment',
      },
    ],
  },
  {
    name: 'menu.researchCenter.admin', // 专业研究发展中心
    key: 'researchCenter/development',
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
  },
  {
    name: 'menu.researchCenter.direction', //研究方向管理
    key: 'researchCenter/direction/index',
    ignore: true,
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
  },
  {
    name: 'menu.researchCenter.direction', //研究方向管理-配置页
    key: 'researchCenter/direction/create',
    ignore: true,
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
  },
  {
    name: 'menu.researchCenter.report', // 研究方向管理-报告详情
    key: 'researchCenter/direction/report',
    ignore: true,
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
  },
  {
    name: 'menu.atlasAi.admin', // 智思体专业分析
    key: 'atlasAi',
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
    children: [
      {
        name: 'menu.atlasAi.home', // 人才培养画像
        key: 'atlasAi/index',
      },
      {
        name: 'menu.atlasAi.fit', // 专业契合度
        key: 'atlasAi/index#fit',
      },
      {
        name: 'menu.atlasAi.scheme', // 培养方案分析
        key: 'atlasAi/index#scheme',
      },
      {
        name: 'menu.atlasAi.employment', // 毕业生行业数据分析
        key: 'atlasAi/index#employment',
      },
    ],
  },
  {
    name: 'menu.atlasAi.detail', // AI专业分析详情
    key: 'atlasAi/detail',
    ignore: true,
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
  },
  {
    name: 'menu.knowledge.graph', // 知识图谱
    key: 'knowledge/graph',
    requiredPermissions: [
      { resource: 'menu.knowledge.graph', actions: ['read'] },
    ],
  },
  {
    name: 'menu.zhisiti.index', // 智思体
    key: 'zhisiti/index',
  },
  {
    name: 'menu.explore.index', // 知识探索
    key: 'explore/index',
    requiredPermissions: [{ resource: 'menu.explore.index', actions: ['*'] }],
  },
  {
    name: 'menu.explore.detail', // 知识探索
    key: 'explore/detail',
    ignore: true,
    requiredPermissions: [{ resource: 'menu.explore.index', actions: ['*'] }],
  },
  {
    name: 'menu.explore.onlyRead', // 知识探索
    key: 'explore/onlyRead',
    ignore: true,
    requiredPermissions: [{ resource: 'menu.explore.index', actions: ['*'] }],
  },
  {
    name: 'menu.knowledgeCheck.list', // 知识查查
    key: 'knowledgeCheck/list',
    requiredPermissions: [
      { resource: 'menu.knowledgeCheck.list', actions: ['read'] },
    ],
  },
  {
    name: 'menu.system.pro', // 专题项目
    key: 'pro',
    requiredPermissions: [{ resource: 'menu.system.pro', actions: ['read'] }],
  },
  {
    name: 'menu.system.scheme', // 培养方案
    key: 'scheme/redirect',
  },
  {
    name: 'menu.system.schemeList', // 培养方案列表
    key: 'scheme/list',
    ignore: true,
  },
  {
    name: 'menu.system.schemeIndex', // 培养方案详情
    key: 'scheme/index',
    ignore: true,
  },
  {
    name: 'menu.system.admin', // 系统管理
    key: 'system',
    requiredPermissions: [
      { resource: 'menu.system.personal', actions: ['read'] },
    ],
    children: [
      {
        name: 'menu.system.course', // 课程体系
        key: 'system/course',
        requiredPermissions: [
          { resource: 'menu.system.course', actions: ['read'] },
        ],
      },
      // {
      //   name: 'menu.system.role',
      //   key: 'system/roles',
      //   requiredPermissions: [
      //     { resource: 'menu.system.role', actions: ['read'] },
      //   ],
      // },
      // {
      //   name: 'menu.system.dictionary',
      //   key: 'system/dictionary',
      //   requiredPermissions: [
      //     { resource: 'menu.system.dictionary', actions: ['read'] },
      //   ],
      // },
      {
        name: 'menu.organizational.management', // 组织管理
        key: 'organizational/management',
        requiredPermissions: [
          { resource: 'menu.organizational.management', actions: ['read'] },
        ],
      },
    ],
  },
  {
    name: 'login.form.login',
    key: 'login',
    ignore: true,
  },
  {
    name: 'menu.system.personal', // 个人中心
    key: 'system/personal',
    ignore: true,
  },
  {
    name: 'menu.sipu.eduChart', // 四谱聊天
    key: 'eduQuads/educhart',
    ignore: true,
  },
  {
    name: 'menu.sipu.abilitydetail', // 新版能力详情
    key: 'eduQuads/abilitydetail',
    ignore: true,
  },
  {
    name: 'menu.sipu.qualitydetail', // 新版素养详情
    key: 'eduQuads/qualitydetail',
    ignore: true,
  },
  {
    name: 'menu.atlasAi.detail', // ai专业分析详情请页
    key: 'atlasAi/detail',
    ignore: true,
  },
  {
    name: 'menu.new.home', // 新的首页
    key: 'home/index',
    ignore: true,
  },
];

export const getName = (path: string, routes) => {
  return routes.find((item) => {
    const itemPath = `/${item.key}`;
    if (path === itemPath) {
      return item.name;
    } else if (item.children) {
      return getName(path, item.children);
    }
  });
};

export const generatePermission = (role: string) => {
  // 仅在开发环境输出日志
  if (process.env.NODE_ENV === 'development') {
    console.log(role, 'role');
  }
  const actions = role === 'admin' ? ['*'] : ['read'];
  const result = {};
  routes.forEach((item) => {
    result[item.name] = actions;
    if (item.children) {
      item.children.forEach((child) => {
        result[child.name] = actions;
      });
    }
  });
  return result;
};

const useRoute = (userPermission): [IRoute[], string] => {
  // 移除权限过滤，所有登录用户都能看到所有路由
  const [permissionRoute] = useState(routes);

  const defaultRoute = useMemo(() => {
    const first = permissionRoute[0];
    if (first) {
      const firstRoute = first?.children?.[0]?.key || first.key;
      return firstRoute;
    }
    return '';
  }, [permissionRoute]);

  return [permissionRoute, defaultRoute];
};

export default useRoute;
